"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Copyright 2013-present, Novivia, Inc.
                    * All rights reserved.
                    */

var _ShareButton = require("./ShareButton");

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _ButtonToolbar = require("react-bootstrap/ButtonToolbar");

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Icon = require("react-fa/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Social sharing bar.
 * @class
 */
var ShareBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ShareBar, _Component);

  function ShareBar() {
    (0, _classCallCheck3.default)(this, ShareBar);
    return (0, _possibleConstructorReturn3.default)(this, (ShareBar.__proto__ || (0, _getPrototypeOf2.default)(ShareBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ShareBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        { className: "sharebar" },
        _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(_Icon2.default, { name: "share-alt" }),
          _react2.default.createElement(
            "strong",
            null,
            " " + this.props.shared + ": "
          )
        ),
        _react2.default.createElement(
          _ButtonToolbar2.default,
          null,
          this.props.services.map(function (service, index) {
            return _react2.default.createElement(_ShareButton2.default, {
              key: index,
              title: _this2.props.title,
              type: service
            });
          })
        )
      );
    }
  }]);
  return ShareBar;
}(_react.Component), _class.propTypes = {
  // Services
  services: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Sharing label.
  shared: _propTypes2.default.string.isRequired,

  // Title
  title: _propTypes2.default.string
}, _class.defaultProps = {
  services: ["google-plus", "facebook", "twitter", "pinterest", "linkedin", "reddit", "email"]
}, _temp);
exports.default = ShareBar;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/ShareBar.jsx
// module id = 577
// module chunks = 15 19